/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：520
 */

import { v } from "./index__part-1"
export { v as a }
export default v
